module.exports = __webpack_public_path__ + "img/credit-card-x.f04b41a1.svg";